import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { initReactI18next } from "react-i18next";
import { AuthProvider } from "./Context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import i18next from "i18next";
import App from "./App";
import "./index.css";

i18next.use(initReactI18next).init({
  resources: {
    hi: {
      translation: {
        LANGUAGE: "ENGLISH",
        LOGIN: "लॉगिन",
        LOGOUT: "लॉग आउट",
        CM: "चलिए साथ मिलकर सोलर ऊर्जा की ताकत को इंदौर के लिए जगाएं",
        MAYOR: "चलिए हम साथ मिलकर एक पर्यावरणीय भविष्य की ओर कदम बढ़ाएं।",
        SOLAR: "सोलार कोई विकल्प नहीं पर्यावरण के प्रति हमारा कर्तव्य है ।",
        CITIZEN: "ग्राहक",
        VENDOR: "विक्रेता",
        REGISTER: "पंजीकरण",
        CARD1: "स्वयं सौर सयंत्र लगाये",
        CARD2: "सौर मित्र बनने हेतु संकल्प पत्र",
        CARD3: "नोटिफिकेशन",
        DASHCARD1: "कॅल्कुलेटर",
        DASHCARD2: "विक्रेता सूची",
        DASHCARD3: "सोलार संबंधित जानकारी",
        DASHCARD4: "सोलर संकल्प",
        DASHCARD5: "ग्रीन सर्टिफिकेट",
      },
    },
    en: {
      translation: {
        LANGUAGE: "हिन्दी",
        LOGIN: "Log In",
        LOGOUT: "LOGOUT",
        CM: "Let's Together Unlock the Power of Solar energy for Indore",
        MAYOR:
          "Let's Take a step towards a Sustainable future today with Har Ghar Solar",
        SOLAR: "सोलार कोई विकल्प नहीं पर्यावरण के प्रति हमारा कर्तव्य है ।",
        CITIZEN: "Citizen",
        VENDOR: "Vendor",
        REGISTER: "Register now",
        CARD1: "Get Solar Installed yourself",
        CARD2: "Citizen Sankalp",
        CARD3: "Notifications",
        DASHCARD1: "Calculator",
        DASHCARD2: "Vendor List",
        DASHCARD3: "Awareness Content",
        DASHCARD4: "Solar Sankalp",
        DASHCARD5: "Green Certificate",
      },
    },
  },
  lng: "hi",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Service Worker of Firebase
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Error registering service worker:", error);
    });
}

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
